import script from "./PlatformHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformHeader.vue?vue&type=script&setup=true&lang=js"

import "./PlatformHeader.vue?vue&type=style&index=0&id=59c0a786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c0a786"]])

export default __exports__